// API Configuration - Import from environment-based config
export { API_CONFIG } from './api'
export { typography, formStyles, colors } from './styles'

// App Configuration
export const APP_CONFIG = {
  NAME: 'SecondLane',
  VERSION: '2.0.0',
  DESCRIPTION: 'Professional Trading Platform',
  SUPPORT_EMAIL: 'support@secondlane.io',
} as const

// Breakpoints (matching Tailwind)
export const BREAKPOINTS = {
  XS: 375,
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  '2XL': 1536,
} as const

// Trading Configuration
export const TRADING_CONFIG = {
  MIN_ORDER_SIZE: 0.01,
  MAX_ORDER_SIZE: 1000000,
  PRICE_PRECISION: 8,
  QUANTITY_PRECISION: 6,
  REFRESH_INTERVAL: 1000, // 1 second
} as const

// Yield Configuration
export const YIELD_CONFIG = {
  MIN_INVESTMENT: 100,
  MAX_INVESTMENT: 10000000,
  DEFAULT_LOCKUP_PERIOD: 30, // days
} as const

// Routes
export const ROUTES = {
  HOME: '/',
  TRADING: '/trading',
  SECONDARIES: '/trading/otc',
  PERPS: '/trading/perps',
  YIELD: '/yield',
  DATA_ROOM: '/data-room',
  PARTNERS: '/partners',
  PROFILE: '/profile',
  PORTFOLIO: '/portfolio',
  SETTINGS: '/profile',
} as const

// Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_PREFERENCES: 'user_preferences',
  THEME: 'theme',
  LANGUAGE: 'language',
} as const

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network connection error. Please check your internet connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  FORBIDDEN: 'Access denied. Please contact support.',
  NOT_FOUND: 'The requested resource was not found.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  SERVER_ERROR: 'Internal server error. Please try again later.',
} as const

// Success Messages
export const SUCCESS_MESSAGES = {
  TRADE_EXECUTED: 'Trade executed successfully',
  PROFILE_UPDATED: 'Profile updated successfully',
  INVESTMENT_CREATED: 'Investment created successfully',
  DOCUMENT_UPLOADED: 'Document uploaded successfully',
} as const

// Profile preferences constants
export const INDUSTRIES_OF_INTEREST = [
  'Artificial Intelligence',
  'Robotics',
  'Aerospace & Defense',
  'Autonomous Vehicles',
  'Biotechnology',
  'Clean Energy',
  'Cybersecurity',
  'Enterprise Software',
  'Financial Technology',
  'Healthcare Technology',
  'Semiconductors',
  'Space Technology',
  'Telecommunications'
] as const

export type IndustryOfInterest = typeof INDUSTRIES_OF_INTEREST[number]

// Investment amount options for onboarding
export const INVESTMENT_AMOUNT_OPTIONS = [
  { value: 10000, label: '$10,000' },
  { value: 50000, label: '$50,000' },
  { value: 100000, label: '$100,000' },
  { value: 250000, label: '$250,000' },
  { value: 500000, label: '$500,000' },
  { value: 1000000, label: '$1,000,000' },
  { value: 5000000, label: '$5,000,000+' }
] as const

export type InvestmentAmountOption = typeof INVESTMENT_AMOUNT_OPTIONS[number]

// Container sizes for consistent layout
export const CONTAINER_SIZES = {
  COMPACT: '4xl',    // For forms, settings, profile
  STANDARD: '6xl',   // For most pages
  WIDE: '9xl',       // For data tables, dashboards
  FULL: 'full'       // For full-width content
} as const

export type ContainerSize = keyof typeof CONTAINER_SIZES 